import { gate } from 'hub-http/gates';
import { userInfoSync } from 'hub-http/userInfo';
import { useMemo } from 'react';
export const GATE_DEFINITIONS = {
  breezeAssistant: gate('Marketplace::Storefront::BreezeAssistant'),
  solutionsSpringSpotlight: gate('Marketplace::Solutions::SpringSpotlight'),
  techPartnerTier: gate('Marketplace::Apps::TechPartnerTier'),
  searchFilterConfigRpc: gate('Marketplace::StorefrontRpc::SearchFilterConfig')
};
function getGates() {
  try {
    return userInfoSync().gates;
  } catch (_unused) {
    return [];
  }
}
export function useGates() {
  const gates = getGates();
  return useMemo(() => Object.fromEntries(Object.entries(GATE_DEFINITIONS).map(([k, g]) => [k, gates.includes(g)])), [gates]);
}